module.exports = __webpack_public_path__ + "static/messageOverview-0d0c2865206bd5e669652a7f91186f86.svg";